(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["lp-twelve-picker"] && !Shopify.designMode) return;
  try {
    document.addEventListener('variant:selected', (event) => {
    if (!(event.target instanceof Element)) return;
    const picker = event.target.closest('variant-picker');
    if (!picker?.querySelector('[data-lp-twelve="product"]')) return;
    const scope = picker.closest('.shopify-section, dialog');
    const form = scope?.querySelector(`product-form-component[data-product-id="${picker.dataset.productId}"]`);
    if (!form) return;
    form.dataset.lpTwelvePending = 'true';
    form.querySelector('[ref="addToCartButton"]')?.setAttribute('disabled', 'true');
    form.querySelector('[ref="acceleratedCheckoutButtonContainer"]')?.setAttribute('hidden', 'true');
  });

  document.addEventListener('variant:update', (event) => {
    if (!(event.target instanceof Element)) return;
    const picker = event.target.closest('variant-picker');
    if (!picker?.querySelector('[data-lp-twelve="product"]')) return;
    const scope = picker.closest('.shopify-section, dialog');
    const form = scope?.querySelector(`product-form-component[data-product-id="${picker.dataset.productId}"]`);
    if (form) delete form.dataset.lpTwelvePending;
  });

  document.addEventListener('submit', (event) => {
    if (!(event.target instanceof HTMLFormElement)) return;
    const form = event.target;
    if (!form.action.includes('/cart/add')) return;
    const component = form.closest('product-form-component');
    const scope = component?.closest('.shopify-section, dialog');
    const picker = component
      ? scope?.querySelector(`variant-picker[data-product-id="${component.dataset.productId}"] [data-lp-twelve="product"]`)
      : form.querySelector('[data-lp-twelve="collection"]');
    const teamPicker = form.querySelector('[data-lp-twelve="team"]');
    if (teamPicker) {
      if (!teamPicker.querySelector('input:checked:not(:disabled)')) {
        event.preventDefault();
        event.stopImmediatePropagation();
      }
      return;
    }
    if (!picker) return;
    const selected = picker.querySelector('input:checked:not(:disabled)');
    const id = form.querySelector('input[name="id"]');
    const selectedId = selected?.dataset.variantId || selected?.value;
    if (!selected || !id || id.disabled || id.value !== selectedId || component?.dataset.lpTwelvePending) {
      event.preventDefault();
      event.stopImmediatePropagation();
    }
  }, true);
  } catch(e) { console.error(e); }
})();

})();
